export default "__VITE_ASSET__yQ$anmRP__"